import { gql, TypedDocumentNode } from "@apollo/client";

import { MutationApiKeyRoleBindingDeleteArgs, ApiKeyRoleBinding } from "types/generated";

type ApiKeyRoleBindingDeleteData = {
  apiKeyRoleBindingDelete: Pick<ApiKeyRoleBinding, "id">;
};

export const API_KEY_ROLE_BINDING_DELETE: TypedDocumentNode<
  ApiKeyRoleBindingDeleteData,
  MutationApiKeyRoleBindingDeleteArgs
> = gql`
  mutation ApiKeyRoleBindingDelete($id: ID!) {
    apiKeyRoleBindingDelete(id: $id) {
      id
    }
  }
`;